import { useReduxState } from 'hooks';
import { ProgressBar } from 'components/common';
import { ProgressLabel } from '.';

interface Props {
  discrepancyInCompletion?: boolean;
  numberOfTasks: number;
  showLabelTitle?: boolean;
  taskMaxPoints: number;
  taskPoints: number;
  taskPointsProgress: number;
}

const TasksPointsProgress = ({
  discrepancyInCompletion,
  numberOfTasks,
  showLabelTitle,
  taskMaxPoints,
  taskPoints,
  taskPointsProgress
}: Props) => {
  const { messages, theme } = useReduxState();

  if (!numberOfTasks) {
    return (
      <div
        style={{
          color: theme.textColorLighter,
          fontSize: '1.3rem',
          whiteSpace: 'nowrap'
        }}
      >
        {messages.tasksNoTasks}
      </div>
    );
  }

  return (
    <div className="progress">
      <ProgressBar
        ariaLabel={messages.tasksTaskPoints}
        color={theme.successStandaloneColor}
        label={
          <ProgressLabel
            discrepancyInCompletion={discrepancyInCompletion}
            title={showLabelTitle ? messages.tasksTaskPoints : undefined}
            value={
              <>
                {`${Math.round(taskPointsProgress * 100)}%`}
                <span
                  style={{
                    color: theme.textColorLighter,
                    marginLeft: 5
                  }}
                >
                  {`(${taskPoints}/${taskMaxPoints})`}
                </span>
              </>
            }
          />
        }
        progress={taskPointsProgress}
        style={{ width: showLabelTitle ? '100%' : 120 }}
      />
    </div>
  );
};

export default TasksPointsProgress;
